module.exports = __webpack_public_path__ + "media/26.3ce30cd3.mp3";